export const stockTickerData = [
    { symbol: 'STL N', price: '27k', change: '+0.16%', positive: true },
    { symbol: 'NFLX', price: '818.07', change: '+40.25%', positive: true },
    { symbol: 'GME', price: '34.61m', change: '+1.10%', positive: true },
    { symbol: 'AMZN', price: '230.07', change: '+45.91%', positive: true },
    { symbol: 'NVDA', price: '139.19', change: '+185.63%', positive: true },
    { symbol: 'MSFT', price: '487.87', change: '+24.69%', positive: true },
    { symbol: 'GOOG', price: '305.99', change: '+60.9%', positive: true },
    { symbol: 'TSLA', price: '488.54', change: '+100.0%', positive: true },
    { symbol: 'AAPL', price: '260.03', change: '+34.47%', positive: true },
    { symbol: 'META', price: '630.03', change: '+78.24%', positive: true },
    { symbol: 'DIS', price: '125.54', change: '+40.49%', positive: true },
    { symbol: 'INTC', price: '19.06', change: '-62.05%', positive: false },
    { symbol: 'AMD', price: '115.93', change: '-21.28%', positive: false },
];

export const etfCategories = [
    {
        title: 'Economic Calendar',
        description: 'Keep an eye on key upcoming economic events, announcements, and news. Plus, set up filters in a few clicks, selecting for event importance and affected currencies.',
        color: '#2563eb'
    },
    {
        title: 'Stock Market',
        description: 'See the top five gaining, losing, and most active stocks for the day. It updates based on current market activity – so you\'ll always see the most relevant stocks.',
        color: '#2563eb'
    },
    {
        title: 'Market Overview',
        description: 'Built for when you need to take a macro look at the markets. This widget works particularly well on homepages.',
        color: '#2563eb'
    },
    {
        title: 'Forex Cross Rates',
        description: 'This one allows you to display real-time quotes of selected currencies in comparison to other major currencies.',
        color: '#2563eb'
    },

];

export const stockListings = [
    // Energy stocks
    [
        { symbol: 'EOG', name: 'EOG Resources Inc.', price: '133.51', change: '+1.20%', positive: true, color: '#e74c3c' },
        { symbol: 'XRT', name: 'Mining and Resources', price: '40.41', change: '+0.82%', positive: true, color: '#3498db' },
        { symbol: 'CVX', name: 'Chevron Corp', price: '152.89', change: '+1.15%', positive: true, color: '#2ecc71' },
        { symbol: 'ENS', name: 'Energy Solutions Group', price: '54.18', change: '-0.45%', positive: false, color: '#9b59b6' },
        { symbol: 'TURN', name: 'Natural Resources Ltd.', price: '11.78', change: '+2.30%', positive: true, color: '#f39c12' },
        { symbol: 'ZRP', name: 'Oil Distribution Inc.', price: '8.94', change: '+0.95%', positive: true, color: '#1abc9c' },
    ],
    // Construction stocks
    [
        { symbol: 'BRY', name: 'Berry Corp', price: '121.39', change: '+1.85%', positive: true, color: '#e67e22' },
        { symbol: 'ZAC', name: 'Construction Holdings', price: '144.72', change: '+2.10%', positive: true, color: '#e74c3c' },
        { symbol: 'CTM', name: 'Building Materials Inc.', price: '67.45', change: '-0.32%', positive: false, color: '#3498db' },
        { symbol: 'DHI', name: 'D.R.H. Holdings', price: '18.11', change: '+0.78%', positive: true, color: '#2ecc71' },
        { symbol: 'LMT', name: 'Infrastructure Corp', price: '91.78', change: '+1.45%', positive: true, color: '#9b59b6' },
    ],
    // Tech stocks
    [
        { symbol: 'QYTR', name: 'Tech Solutions Inc.', price: '103.29', change: '+3.25%', positive: true, color: '#3498db' },
        { symbol: 'MSFT', name: 'Microsoft Corp', price: '487.42', change: '+1.89%', positive: true, color: '#00a4ef' },
        { symbol: 'RYLD', name: 'Cloud Services Ltd.', price: '16.45', change: '-0.65%', positive: false, color: '#9b59b6' },
        { symbol: 'MTK', name: 'Semiconductor Inc.', price: '658.18', change: '+2.78%', positive: true, color: '#e74c3c' },
        { symbol: 'GOOG', name: 'Alphabet Inc.', price: '311.76', change: '+1.54%', positive: true, color: '#34a853' },
        { symbol: 'NFLX', name: 'Netflix Inc.', price: '789.05', change: '+4.12%', positive: true, color: '#e50914' },
    ],
    // Automatic stocks
    [
        { symbol: 'CAT', name: 'Caterpillar, Inc.', price: '578.26', change: '-0.08%', positive: false, color: '#e67e22' },
        { symbol: 'DAL', name: 'Delta Air Lines, Inc.', price: '69.38', change: '-0.22%', positive: false, color: '#e74c3c' },
        { symbol: 'FORD', name: 'Ford Motor Company', price: '11.298', change: '-0.05%', positive: false, color: '#3498db' },
        { symbol: 'MERCEDES', name: 'Mercedes-Benz Group AG', price: '22.995', change: '-1.14%', positive: false, color: '#2ecc71' },
        { symbol: 'HYU', name: 'Hyundai Motor', price: '34.50', change: '+0.00%', positive: true, color: '#9b59b6' },
        { symbol: 'BMW', name: 'Bayerische Motoren Werke', price: '93.47', change: '+1.10%', positive: true, color: '#2ecc71' },
    ],
    // Agriculture stocks

];
